import $ from "jquery";
import Backbone from "backbone";

const hijackPreventionPrefix = ")]}',";

export default Backbone.Model.extend({
  fetch () {
    const model = this; // eslint-disable-line consistent-this

    return $.ajax({
      url: "/api/v1/me",

      converters: {
        "text json": (result) => {
          let cleanResult = result;

          if (result.startsWith(hijackPreventionPrefix)) {
            cleanResult = result.slice(hijackPreventionPrefix.length);
          }

          const attr = JSON.parse(cleanResult);

          model.set("isNewsLetterEnabled", attr.newsletterSignup);
          model.set("venueCommunicationSettings", attr.venueCommunicationSettings);
        }
      }
    });
  }
});
